import SearchModel from'./SearchModel';
class OPMModel {
    id              = -1
    numberOPM           = ""
    ini_organ         = ""
    ini_direction            =""
    ini_name            =""
    executor            =""
    storage            =""
    infoOPM            =""
    typeExecutor            =""
    idProc = -1
    searchModel = null;
}

export default OPMModel